import React from 'react';
import { KeenIcon } from '@/components';

const ActionButton = ({ onClick }) => (
    <>
        <button
            className="flex items-center justify-center rounded-lg bg-gray-50 border hover:bg-gray-100 px-2 h-8"
            onClick={onClick}
            title="Delete"
            type="button"
        >
            <KeenIcon icon="trash" className="text-2xl text-red-500" />
        </button>

        <button
            className="flex items-center justify-center rounded-lg bg-gray-50 border hover:bg-gray-100 px-2 h-8"
            onClick={onClick}
            title="Share"
            type="button"
        >
            <KeenIcon icon="share" className="text-2xl text-blue-500" />
        </button>
    </>
);

export { ActionButton };   
